import type { FormValue } from '../../types';
import type { LayoutNode } from './types';
import { sumComputedScores } from './computedScore';

/**
 * Computes all `sum` reductions in layout order; later duplicates of the same `id` overwrite earlier.
 */
export function computeLayoutDerivedTotals(
  nodes: LayoutNode[],
  answers: Record<string, FormValue>
): Record<string, number> {
  const map: Record<string, number> = {};

  const walk = (arr: LayoutNode[]): void => {
    for (const node of arr) {
      switch (node.type) {
        case 'sum':
          map[node.id] = sumComputedScores(answers, node.terms);
          break;
        case 'card':
        case 'stack':
        case 'grid':
        case 'indent':
          walk(node.children);
          break;
        case 'conditional':
          walk(node.children);
          if (node.elseChildren) walk(node.elseChildren);
          break;
        case 'disabled-when':
          walk(node.children);
          break;
        case 'repeat':
          walk(node.children);
          break;
        case 'table':
          for (const row of node.rows) {
            for (const cell of row.cells) walk([cell]);
          }
          break;
        case 'OASISMultiselect':
          if (node.children) walk(node.children);
          break;
        default:
          break;
      }
    }
  };

  walk(nodes);
  return map;
}
